module.exports = __webpack_public_path__ + "static/media/P3_S1_1.e2ad6d62.png";